module.exports = __webpack_public_path__ + "img/m16.e9e77d2.jpg";